import fastPrevIcon from "../assets/img/icon-fast-prev.png";
import prevIcon from "../assets/img/icon-prev.png";
import fastnextIcon from "../assets/img/icon-fast-next.png";
import nextIcon from "../assets/img/icon-next.png";

export const Pagination = (props) => {
  // Normalize props (support both shapes)
  const page = props.page ?? props.data?.page ?? 1;

  const totalCount = props.totalCount ?? props.data?.totalCount ?? 0;

  const limit = props.limit ?? props.data?.limit ?? 10;

  const totalPages = Math.max(1, Math.ceil(totalCount / limit));

  // Unified setter
  const emit = (p) => {
    if (props.onChange) return props.onChange(p); // new API
    if (props.setCurrentPage) return props.setCurrentPage(p); // old API
    // no-op if neither is provided (keeps other modules from crashing)
    console.warn("[Pagination] No onChange/setCurrentPage provided");
  };

  const go = (target) => {
    if (typeof target !== "number") return;
    const next = Math.min(Math.max(target, 1), totalPages);
    if (next !== page) emit(next);
  };

  // Build compact array of page numbers
  const paginationArray = [];
  if (totalPages <= 6) {
    for (let i = 1; i <= totalPages; i++) paginationArray.push(i);
  } else {
    paginationArray.push(1);
    if (page > 3) paginationArray.push("...");
    for (
      let i = Math.max(2, page - 1);
      i <= Math.min(totalPages - 1, page + 1);
      i++
    ) {
      paginationArray.push(i);
    }
    if (page < totalPages - 2) paginationArray.push("...");
    paginationArray.push(totalPages);
  }

  const canPrev = page > 1;
  const canNext = page < totalPages;

  const onPageClick = (item) => () => {
    if (typeof item === "number") go(item);
  };

  return (
    <ul className="pagination">
      <li
        role="button"
        tabIndex={0}
        onClick={() => canPrev && go(page - 4)}
        className={!canPrev ? "disabled" : ""}
      >
        <img src={fastPrevIcon} alt="First" />
      </li>
      <li
        role="button"
        tabIndex={0}
        onClick={() => canPrev && go(page - 1)}
        className={!canPrev ? "disabled" : ""}
      >
        <img src={prevIcon} alt="Prev" />
      </li>

      {paginationArray.map((item, index) => (
        <li
          role={typeof item === "number" ? "button" : "presentation"}
          tabIndex={typeof item === "number" ? 0 : -1}
          onClick={onPageClick(item)}
          key={index}
          className={
            item === page
              ? "active"
              : typeof item !== "number"
              ? "ellipsis"
              : ""
          }
          style={{ cursor: typeof item === "number" ? "pointer" : "default" }}
        >
          {item}
        </li>
      ))}

      <li
        role="button"
        tabIndex={0}
        onClick={() => canNext && go(page + 1)}
        className={!canNext ? "disabled" : ""}
      >
        <img src={nextIcon} alt="Next" />
      </li>
      <li
        role="button"
        tabIndex={0}
        onClick={() => canNext && go(page + 4)}
        className={!canNext ? "disabled" : ""}
      >
        <img src={fastnextIcon} alt="Last" />
      </li>
    </ul>
  );
};
